import React from "react";
import { useTranslation } from "react-i18next";
import { ColorPicker } from "@common/colorPicker";
import { SelectList } from "@common/selectList";
import styles from "./styles.scss";
import icon from "./icon.svg";
import { Props } from "./types";

function ColorPickerInput({ strategicAxis, setStrategicAxis }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <input
          type="text"
          className={styles.input}
          placeholder={t("strategicAxesPage.creation.placeholders.code")}
          value={strategicAxis.code}
          onChange={({ target }) => {
            setStrategicAxis({ ...strategicAxis, code: target.value });
          }}
        />
      </div>
      <SelectList rootClassName={styles.colorPickerInput}>
        {() => ({
          input: (
            <div
              className={styles.iconBox}
              style={{ backgroundColor: strategicAxis.color }}
            >
              <img
                className={styles.icon}
                src={icon}
                alt="icon"
                onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
              />
            </div>
          ),
          list: (
            <ColorPicker
              color={strategicAxis.color}
              pick={(color) => setStrategicAxis({ ...strategicAxis, color })}
            />
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ColorPickerInput };
